import store from '@/store/index';
const tenantCode = store.getters.currentTenant.tenantCode;
export default {
    'searchList': {
        'searchTxt': [{
            'name': '账单号',
            'value': 'apBillNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        },
        {
            'name': '发票号',
            'value': 'ledgerName',
            'type': 'input',
            'unfold': true,
            'span': 3
        },
        {
            'name': '创建时间',
            'value': 'createTime',
            'startTime': 'createTimeFrom',
            'endTime': 'createTimeTo',
            'type': 'time',
            'timeNum': 7,
            'unfold': true,
            'span': 6
        },
        {
            'name': '状态',
            'value': 'billStatus',
            'type': 'select',
            'unfold': true,
            'span': 2,
            'data': '',
            'optionNum': 'SYS_BMS_BILL_STATUS',
            'multiple': false
        },
        {
            'name': '结算流程',
            'value': 'settlementProcess',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'optionNum': 'BMS_SETTLEMENT_PROCESS',
            'multiple': false
        }
        ],
        'unfoldState': false,
        'advancedBtn': true
    },
    'searchTotalTitle': [
        {
            'name': '确认时间',
            'value': 'subdate2',
            'startTime': 'startSubdateTime',
            'endTime': 'endSubdateTime',
            'type': 'time',
            'unfold': true,
            'span': 7
        },
        // {
        //     'name': '开票时间',
        //     'value': 'openInvoiceDate',
        //     'startTime': 'startInvoiceTime',
        //     'endTime': 'endInvoiceTime',
        //     'type': 'time',
        //     'unfold': true,
        //     'span': 7
        // },
        {
            'name': '收票日期',
            'value': 'signForTime',
            'startTime': 'startExpireDateTime',
            'endTime': 'endExpireDateTime',
            'type': 'time',
            'unfold': true,
            'span': 7
        },
        {
            'name': '付款日期',
            'value': 'checkDate',
            'startTime': 'startPaymentTime',
            'endTime': 'endPaymentTime',
            'type': 'time',
            'unfold': true,
            'span': 7
        },
        {
            'name': '服务平台',
            'value': 'siteName',
            'unfold': true,
            'advanceConfig': [
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
            ],
            'tableConfig': [
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' },
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' }
            ],
            'advanceUrl': '/searchPlatform',
            'type': 'advance',
            'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
            'span': 3
        },
        {
            'name': '客户名称',
            'value': 'accountName',
            'advanceLabel': '客户名称',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'operatingUnitName', 'value': '客户名称' },
                { 'prop': 'operatingUnitId', 'value': '客户编码' }
            ],
            'tableConfig': [
                { 'prop': 'operatingUnitName', 'value': '客户名称' },
                { 'prop': 'operatingUnitId', 'value': '客户编码' },
                { 'prop': 'companyName', 'value': '公司名称' }
            ],
            'cbParams': ['operatingUnitName#accountName#companyName', 'operatingUnitId#ledgerId#companyName'],
            'advanceUrl': '/common/anntoFeeHead/efOrganRelation/page?enabledFlag=1&tenantCode=' + tenantCode,
            'prefix': 'api-bcp-web'
        },
        {
            'name': '分公司',
            'value': 'companyNameNew',
            'unfold': true,
            'advanceConfig': [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCodeNew', 'value': '分公司编码' }
            ],
            'tableConfig': [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCodeNew', 'value': '分公司编码' }
            ],
            'advanceUrl': '/esCompany/popCompany',
            'type': 'advance',
            'cbParams': ['companyCode#companyCodeNew', 'companyNameCn#companyNameNew'],
            'span': 3
        },
        {
            'name': '付款条件',
            'value': 'subnum4',
            'type': 'select',
            'unfold': true,
            'span': 2,
            'optionNum': 'SYS_SU_PAYMENT_TERMS',
            'multiple': false
        },
        {
            'name': '结算单号',
            'value': 'apApplyNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        },
        {
            'name': '币种',
            'value': 'currencyCode',
            'type': 'input',
            'unfold': true,
            'span': 3
        }
    ],
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'fixedSeletionColumn': true,
        'columns': [
            {
                'label': '账单号',
                'prop': 'apBillNo',
                'width': '148px'
            },
            {
                'label': '客户名称',
                'prop': 'ledgerName',
                'width': '148px'
            },
            {
                'label': '分公司',
                'prop': 'companyNameNew',
                'width': '100px'
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'width': '110px'
            },
            {
                'label': '会计主体',
                'prop': 'ledgerName',
                'width': '260px'
            },
            {
                'label': '币种',
                'prop': 'currencyCode',
                'width': '60px'
            },
            // {
            //     'label': '付款合计金额',
            //     'prop': 'totalAmt',
            //     'width': '100px'
            // },
            {
                'label': '应收款金额',
                'prop': 'apRealAmt',
                'width': '100px'
            },
            {
                'label': '核销总金额',
                'prop': 'verifyTotalAmt',
                'width': '80px'
            },
            {
                'label': '单据状态',
                'prop': 'billStatusTest',
                'width': '80px'
            },
            {
                'label': '已开票金额',
                'prop': 'invoiceAmt',
                'width': '88px'
            },
            {
                'label': '已付款金额',
                'prop': 'payedAmt',
                'width': '88px'
            },
            {
                'label': '结算流程',
                'prop': 'settlementProcessName',
                'width': '88px'
            },
            {
                'label': '结算单号',
                'prop': 'apApplyNo',
                'width': '88px'
            },
            {
                'label': '备注',
                'prop': 'remark',
                'width': '160px'
            },
            {
                'label': '账单确认时间',
                'prop': 'subdate2',
                'width': '160px'
            },
            {
                'label': '开票日期',
                'prop': 'openInvoiceDate',
                'width': '160px'
            },
            {
                'label': '收票日期',
                'prop': 'signForTime',
                'width': '160px'
            },
            {
                'label': '付款日期',
                'prop': 'checkDate',
                'width': '160px'
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'width': '160px'
            },
            {
                'label': '快递单号',
                'prop': 'deliveryNo',
                'width': '160px'
            },
            {
                'label': '付款条件',
                'prop': 'subnum4',
                'width': '160px'
            }
        ],
        'leftOperation': false
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    }
};
